export class RiskState {
	public keyRateSelectedCurrency: string;
}
